import React, { useState, useEffect ,useRef} from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,Box,DefaultTableCell,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useAuth } from "../../../AuthProvider"; 
import { GlobalStyles } from "@mui/system";
import { MenuItem, Select, } from "@mui/material";



function Complaint() {
 

  const [filteredData, setFilteredData] = useState([]);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { userId, oId ,userRoleName,pId} = useAuth(); 
  const [loading, setLoading] = useState(false);

  const [searchDate, setSearchDate] = useState(""); // State to store selected date

  const [statusData, setStatusData] = useState({}); // Store selected statuses
  const [loadingSave, setLoadingSave] = useState({}); // Store loading state per row


 

  
//   const fetchComplaints = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${baseUrl}/api/complaints/getAll/${oId}/${pId}`);
  
//       if (!response.ok) {
//         throw new Error("Failed to fetch complaints");
//       }
  
//       const data = await response.json();

//      // ✅ Sort complaints: Pending first, then Resolved, sorted by date (newest first)
//      data.sort((a, b) => {
//       const statusA = a.status.toLowerCase();
//       const statusB = b.status.toLowerCase();

//       if (statusA === "pending" && statusB !== "pending") return -1; // Pending first
//       if (statusA !== "pending" && statusB === "pending") return 1;
      
//       return new Date(b.date) - new Date(a.date); // Sort by date (newest first)
//     });

//       setFilteredData(data); // ✅ Update state with fetched data

//     } catch (error) {
//       console.error("Error fetching complaints:", error);
//       // toast.error("An error occurred while fetching data.");
//     } finally {
//       setLoading(false);
//     }
//   };
  
// useEffect(() => {
//   if (oId && pId) {
//     fetchComplaints();
//   }
// }, [oId, pId]); 

  
 
// ✅ Prevent duplicate fetch
  const hasFetched = useRef(false);

  const fetchComplaints = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${baseUrl}/api/complaints/getAll/${oId}/${pId}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch complaints");
      }

      const data = await response.json();

      // ✅ Sort complaints
      data.sort((a, b) => {
        const statusA = a.status.toLowerCase();
        const statusB = b.status.toLowerCase();

        if (statusA === "pending" && statusB !== "pending") return -1;
        if (statusA !== "pending" && statusB === "pending") return 1;

        return new Date(b.date) - new Date(a.date);
      });

      setFilteredData(data);
    } catch (error) {
      console.error("Error fetching complaints:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // ✅ wait until context has values
    if (oId && pId && !hasFetched.current) {
      fetchComplaints();
      hasFetched.current = true; // ensure it's called only once
    }
  }, [oId, pId]);



  const filteredResults = filteredData.filter((item) => {
    if (!searchDate) return true; // If no date is selected, show all results
  
    return item.date === searchDate; // Filter based on exact date match
  });
  
  





  

 // Function to handle dropdown change
// const handleStatusChange = (event, rowId) => {
//   setStatusData((prev) => ({ ...prev, [rowId]: event.target.value }));
// };

const handleStatusChange = (rowId, newStatus) => {
  setStatusData((prev) => ({ ...prev, [rowId]: newStatus }));
};

const getStatusColor = (status) => {
  const normalizedStatus = status?.trim().toLowerCase();
  return normalizedStatus === "resolved" ? "#4CAF50" : "#FFC107"; // Green for Resolved, Yellow for Pending
};








// Function to save the updated status
const handleSaveStatus = async (row) => {
  try {
    const selectedStatus = statusData[row.id] ?? row.status; // Get the selected or existing status

    
     // ✅ Check if status is NOT "Resolved"
     if (selectedStatus !== "Resolved") {
      toast.error("Please select 'Resolved' before saving.");
      return;
    }

    setLoadingSave((prev) => ({ ...prev, [row.id]: true })); // Start loading

    const updatedStatus = statusData[row.id] || row.status; // Get selected status

    // Create FormData and append the status field
    const formData = new FormData();
    formData.append("status", updatedStatus);

    const response = await fetch(`${baseUrl}/api/complaints/updateComplaintStatus/${row.id}/${oId}`, {
      method: "PATCH",
      body: formData, // Send FormData instead of JSON
    });

    if (!response.ok) {
      throw new Error("Failed to update status.");
    }

    toast.success("Complaint Resolved successfully!");

    // ✅ Refresh the complaints list after update
    fetchComplaints();
  } catch (error) {
    console.error("Error updating status:", error);
    toast.error("Error updating status.");
  }finally {
    setLoadingSave((prev) => ({ ...prev, [row.id]: false })); // Stop loading
  }
};



// const getStatusColor = (status) => {
//   const normalizedStatus = status?.trim().toLowerCase();
//   return normalizedStatus === "resolved" ? "#4CAF50" : "#FFC107"; // Green for Resolved, Yellow for Pending
// };



  

  return (
    <Card
     style={{ 
      margin: "60px 20px 0px 20px",
      padding: "10px",
      backgroundColor: "#ffffff",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      borderRadius: "8px",  
      }}>
      <CardContent>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="h6" style={{ fontWeight: "bold", color: "#333" }}>
              Complaints List
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2} alignItems="center" justifyContent="space-between" style={{ marginTop: "1px" }}>
          <Grid item xs={3}>
          {/* <TextField
              label="Search by Name"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ width: "150px" }} // Adjust width as needed
            /> */}

          <TextField
            label="Search by Date"
            type="date"
            variant="outlined"
            size="small"
            value={searchDate}
            onChange={(e) => setSearchDate(e.target.value)}
            InputLabelProps={{ shrink: true }} // Ensures label does not overlap with date value
            sx={{ width: "180px" }} // Adjust width as needed
          />

          </Grid>

          
        </Grid>

        <GlobalStyles
                  styles={{
                    '.custom-sidebar-scrollbar': {
                      scrollbarWidth: 'thin', // For Firefox
                      scrollbarColor: 'grey #e0e0e0',
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                      width: '6px', // For WebKit-based browsers
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                      background: '#f1f1f1', // Track color
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                      backgroundColor: 'grey', // Thumb color
                      borderRadius: '10px',
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#555',
                    },
                  }}
                />

        <TableContainer 
        component={Paper} 
        style={{ marginTop: "20px", borderRadius: "8px", maxHeight: "420px", overflowY: "auto" }}
         className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
            <TableRow>
  <TableCell
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4",
      fontWeight:"bold",
      fontSize: "14px",
      padding: "6px", // Reduced padding
      lineHeight: "1.2" // Adjust line height for compact display
    }}
  >
    S.No
  </TableCell>
  <TableCell 
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", 
      fontWeight:"bold",
      lineHeight: "1.2"
      
    }}
  >
    Date
  </TableCell>
  <TableCell 
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", 
      fontWeight:"bold",
      lineHeight: "1.2"
    }}
  >
    Time
  </TableCell>
  <TableCell 
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", 
      fontWeight:"bold",
      lineHeight: "1.2"
    }}
  >
    Complaint Raised On
  </TableCell>
  <TableCell 
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", 
      fontWeight:"bold",
      lineHeight: "1.2"
    }}
  >
    Complaint Given by
  </TableCell>
  <TableCell 
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", 
      fontWeight:"bold",
      lineHeight: "1.2"
    }}
  >
    Complaint
  </TableCell>
  <TableCell 
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", 
      fontWeight:"bold",
      lineHeight: "1.2"
    }}
  >
    Status
  </TableCell>
  <TableCell 
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", 
      fontWeight:"bold",
      lineHeight: "1.2"
    }}
  >
    Action
  </TableCell>
</TableRow>

            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={8} style={{ textAlign: "center", padding: "20px" }}>
                                          <Box display="flex" flexDirection="column" alignItems="center">
                                            <CircularProgress />
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                              Loading Data...
                                            </Typography>
                                          </Box>
                                        </TableCell>
                </TableRow>
              ) : filteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredResults.map((row, index) => (
                  <TableRow 
                  key={row.id} 
                  sx={{ 
                    backgroundColor: "white", 
                    transition: "background-color 0.3s", 
                    // height: "30px" // Reduced row height 
                  }}
                >
                  <TableCell 
                    sx={{ 
                      border: "1px solid #ddd", 
                      textAlign: "center", 
                      fontSize: "14px", 
                      padding: "4px", // Reduced padding
                      // lineHeight: "1.2"
                    }}
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell 
                    sx={{ 
                      border: "1px solid #ddd", 
                      textAlign: "center", 
                      fontSize: "14px", 
                      padding: "4px", 
                      // lineHeight: "1.2"
                    }}
                  >
                    {row.date}
                  </TableCell>
                  <TableCell 
                    sx={{ 
                      border: "1px solid #ddd", 
                      textAlign: "center", 
                      fontSize: "14px", 
                      padding: "4px", 
                      // lineHeight: "1.2"
                    }}
                  >
                    {row.time}
                  </TableCell>
                  {/* <TableCell 
                    // sx={{ 
                    //   border: "1px solid #ddd", 
                    //   textAlign: "center", 
                    //   fontSize: "14px", 
                    //   padding: "4px", 
                    //   // lineHeight: "1.2"
                    // }}
                   
                  >
                    {row.name}
                  </TableCell> */}
                  <TableCell
  sx={{
    border: "1px solid #ddd",
    textAlign: "center",
    fontSize: "14px",
    padding: "4px",
  }}
>
  <Box
    sx={{
      maxHeight: "40px",
      overflowY: "hidden",
      lineHeight: 1.3,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      '&:hover': {
        overflowY: 'auto',
      },
    }}
  >
    {(() => {
      const lines = row.name?.split('\n') || [];
      const firstLine = lines[0] || '';
      const lastLine = lines[lines.length - 1] || '';
      return (
        <>
          <Box>{lastLine}</Box>
          <Box>({firstLine})</Box>
        </>
      );
    })()}
  </Box>
</TableCell>

{/* 
                  <TableCell 
                    sx={{ 
                      border: "1px solid #ddd", 
                      textAlign: "center", 
                      fontSize: "14px", 
                      padding: "4px", 
                      // lineHeight: "1.2"
                    }}
                  >
                    {row.complaintGivenBy}
                  </TableCell> */}
                 <TableCell
  sx={{
    border: "1px solid #ddd",
    textAlign: "center",
    fontSize: "14px",
    padding: "4px",
  }}
>
  <Box
    sx={{
      maxHeight: "40px",
      overflowY: "hidden",
      lineHeight: 1.3,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      '&:hover': {
        overflowY: 'auto',
      },
    }}
  >
    {(() => {
      const lines = row.complaintGivenBy?.split('\n') || [];
      const firstLine = lines[0] || '';
      const lastLine = lines[lines.length - 1] || '';
      return (
        <>
          <Box>{lastLine}</Box>
          <Box>({firstLine})</Box>
        </>
      );
    })()}
  </Box>
</TableCell>



                  <TableCell 
  sx={{ 
    border: "1px solid #ddd", 
    textAlign: "center", 
    fontSize: "14px", 
    padding: "4px", 
    // lineHeight: "1.2",
    maxWidth: "200px" // Set a max width for better structure
  }}
>
  <Box
    sx={{
      maxHeight: "50px", // Set a fixed height
      overflowY: "auto", // Enable scrolling
      padding: "2px",
      textAlign: "center",
      whiteSpace: "pre-wrap", // Ensures text wraps properly
    }}
  >
    {row.complaintDescription}
  </Box>
</TableCell>



<TableCell
sx={{ 
                      border: "1px solid #ddd", 
                      textAlign: "center", 
                      fontSize: "14px", 
                      padding: "4px", 
                      // lineHeight: "1.2"
                    }}

>
  <select
    id={`select-${row.id}`}
    value={statusData[row.id] ?? row.status} // Show actual status
    onChange={(e) => handleStatusChange(row.id, e.target.value)}
    style={{
      width: "100px",
      height: "35px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      backgroundColor: "#f9f9f9",
      fontSize: "14px",
      color: getStatusColor(statusData[row.id] ?? row.status),
      cursor: "pointer",
      fontWeight: "bold",
    }}
  >
    <option value="Pending" style={{ backgroundColor: "#FFC107", color: "#000" }}>Pending</option>
    <option value="Resolved" style={{ backgroundColor: "#4CAF50", color: "#fff" }}>Resolved</option>
  </select>
</TableCell>

{/* Save Button */}
<TableCell sx={{ border: "1px solid #ddd", textAlign: "center", fontSize: "14px", margin: "3px" }}>
  <Button
    variant="contained"
    sx={{
      backgroundColor: "#1976d2",
      color: "#fff",
      "&:hover": { backgroundColor: "#1565c0" },
    }}
    onClick={() => handleSaveStatus(row)}
    disabled={loadingSave[row.id]} // Disable while loading
  >
   {loadingSave[row.id] ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "SAVE"}
  </Button>
</TableCell>




                </TableRow>
                
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>


        <ToastContainer position="top-right" autoClose={1000} />
      </CardContent>
    </Card>
  );
}

export default Complaint;